import { cva, VariantProps } from 'class-variance-authority';

export const banner = cva(['p-4', 'relative'], {
  variants: {
    color: {
      inform: ['bg-blue-100', 'text-blue-800'],
      warn: ['bg-yellow-100', 'text-yellow-700'],
      negative: ['bg-red-100', 'text-red-700'],
      positive: ['bg-green-100', 'text-green-800'],
      neutral: ['bg-neutral-200', 'text-neutral-700'],
    },
    arrow: {
      true: [
        'mt-4',
        'before:content-[""]',
        'before:w-4',
        'before:h-4',
        'before:absolute',
        'before:rotate-45',
        'before:-top-2',
      ],
      false: [],
    },
    rounded: {
      true: ['rounded'],
      false: [],
    },
  },
  compoundVariants: [
    {
      color: 'inform',
      arrow: true,
      className: ['before:bg-blue-100'],
    },
    {
      color: 'warn',
      arrow: true,
      className: ['before:bg-yellow-100'],
    },
    {
      color: 'negative',
      arrow: true,
      className: ['before:bg-red-100'],
    },
    {
      color: 'positive',
      arrow: true,
      className: ['before:bg-green-100'],
    },
    {
      color: 'neutral',
      arrow: true,
      className: ['before:bg-neutral-200'],
    },
    {
      rounded: true,
      arrow: true,
      className: ['before:rounded-sm'],
    },
  ],
  defaultVariants: {
    color: 'inform',
  },
});

export type StyleProps = VariantProps<typeof banner>;
